import React, { createRef, useEffect, useRef, useState } from "react";
import clsx from "clsx";
import styles from "../styles/ToggleButtons.module.scss";

interface Props {
  items: string[];
  selectedIndex: number;
  onSelectIndex(index: number): void;
}
const ToggleButtons: React.FC<Props> = ({
  items,
  selectedIndex,
  onSelectIndex,
}) => {
  const elementsRef = useRef(items.map(() => createRef<HTMLDivElement>()));
  const [indicatorStyle, setIndicatorStyle] = useState({
    width: 0,
    height: 0,
    x: 0,
    y: 0,
  });

  useEffect(() => {
    const el = elementsRef.current[selectedIndex]?.current;
    if (el) {
      setIndicatorStyle({
        width: el.clientWidth,
        height: el.clientHeight,
        x: el.offsetLeft,
        y: el.offsetTop,
      });
    }
  }, [selectedIndex]);

  return (
    <div className={clsx("row ai-center relative", styles.toggle)}>
      {indicatorStyle.width > 0 && (
        <div
          className={styles.indicator}
          style={{
            width: indicatorStyle.width,
            height: indicatorStyle.height,
            left: indicatorStyle.x,
            top: indicatorStyle.y,
          }}
        />
      )}
      {items.map((item, index) => (
        <div
          key={`${item}_${index}`}
          className={clsx(styles.toggleButton, {
            [styles.toggledButton]: selectedIndex === index,
          })}
          onClick={() => onSelectIndex(index)}
          ref={elementsRef.current[index]}
        >
          <div className={styles.toggleText}>{item}</div>
        </div>
      ))}
    </div>
  );
};

export { ToggleButtons };
